import { quotePageState } from "@/atoms/quote/quote-page-state";
import { PaginationSize } from "@/common/enum/pagination-size";
import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { TableHeader } from "@/types/table-header";
import { Table } from "flowbite-react";
import { useRecoilValue } from "recoil";
import { CustomCell } from "../CustomCell";
import { AdminQuoteFooter } from "./AdminQuoteFooter";
import { AdminQuoteRow } from "./AdminQuoteRow";

const headers: TableHeader[] = [
  { title: "No", width: "w-[52px]" },
  { title: "견적 일자", width: "w-[105px]" },
  { title: "견적 번호", width: "w-[129px]" },
  { title: "파트너명", width: "w-[120px]" },
  { title: "견적 금액", width: "w-[120px]" },
  { title: "견적 품목", width: "w-[335px]" },
  { title: "고객명", width: "w-[120px]" },
  { title: "공사명", width: "w-[335px]" },
  { title: "공종명", width: "w-[335px]" },
];

export const AdminQuoteTable = () => {
  const page = useRecoilValue(quotePageState);
  const items = page.contents;
  const totalElements = page.totalElements;
  const currentPage = page.currentPage;
  const startIndex = totalElements - (currentPage - 1) * PaginationSize.SIZE_12;

  return (
    <div className="w-full overflow-x-auto rounded-lg border">
      <Table>
        <Table.Head>
          {headers.map((header) => (
            <Table.HeadCell
              key={header.title}
              className={header.width + " h-[52px] p-0 border-b"}
            >
              <div className={header.align}>
                <CustomCell>
                  <Footnote12Description
                    className={"text-semantic-text-secondary"}
                  >
                    {header.title}
                  </Footnote12Description>
                </CustomCell>
              </div>
            </Table.HeadCell>
          ))}
        </Table.Head>
        <Table.Body className="divide-y">
          {items.map((item, index) => (
            <AdminQuoteRow
              key={item.id}
              data={item}
              index={index}
              startIndex={startIndex}
            />
          ))}
          <AdminQuoteFooter headersLength={Object.values(headers).length + 2} />
        </Table.Body>
      </Table>
    </div>
  );
};
